@if (isEditable()) {
  <span
    class="custom-icon-inline"
    [class.custom-icon-inline--with-bg]="showBackground()"
    [style.color]="colorStyle()"
    [style.background-color]="bgColor()"
    [matMenuTriggerFor]="iconPickerMenu"
    (click)="$event.stopPropagation()"
    dojoStopPropagation
  >
    @if (iconType() === 'img') {
      <img [src]="name()" alt="" class="custom-icon-img" />
    } @else {
      <i [class]="faClass()"></i>
    }
  </span>
  <mat-menu #iconPickerMenu="matMenu" class="icon-picker-panel-menu">
    <div (click)="$event.stopPropagation()" dojoStopPropagation>
      <dojo-icon-picker-wrapper
        (iconSelected)="selectIcon($event)"
        [initialTab]="initialPickerTab()"
        [initialFaColor]="initialPickerFaColor()"
        [initialShowBackground]="initialPickerShowBg()"
        [activeIconValue]="activeIconValue()"
      />
      <button type="button" class="remove-icon-btn" (click)="removeIcon()">Remove icon</button>
    </div>
  </mat-menu>
} @else {
  <span
    class="custom-icon-inline"
    [class.custom-icon-inline--with-bg]="showBackground()"
    [style.color]="colorStyle()"
    [style.background-color]="bgColor()"
  >
    @if (iconType() === 'img') {
      <img [src]="name()" alt="" class="custom-icon-img" />
    } @else {
      <i [class]="faClass()"></i>
    }
  </span>
}
